export const environment = {
  production: true,
  hmr: false,
  api: "http://localhost:4300",
  socketServer: "localhost:3344"
};
